import { alertActions } from 'actions/alert.actions';
import AppInfoService from 'services/app-info.service';
import { actions } from './actionTypes';

export const getAppInfo = () => {
  return (dispatch: any) => {
    dispatch(actions.getAppInfo());
    AppInfoService.getAppInfo()
      .then((res: any) => {
        dispatch(actions.getAppInfoSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getAppInfoFail(err));
      });
  };
};

export const updateAppInfo = (params: any) => {
  return (dispatch: any) => {
    dispatch(actions.updateAppInfo());
    AppInfoService.updateAppInfo(params)
      .then((res: any) => {
        dispatch(actions.updateAppInfoSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.updateAppInfoFail(err));
        dispatch(alertActions.error(err?.message))
      });
  };
};

export const getListCategory = () => {
  return (dispatch: any) => {
    dispatch(actions.getListCategory());
    AppInfoService.getListCategory()
      .then((res: any) => {
        dispatch(actions.getListCategorySuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getListCategoryFail(err));
      });
  };
};

export const submitApp = () => {
  return (dispatch: any) => {
    dispatch(actions.submitApp());
    AppInfoService.submitApp()
      .then((res: any) => {
        dispatch(alertActions.success('Submit Successful'));
        dispatch(getAppInfo())
        dispatch(actions.submitAppSuccess());
        dispatch(actions.toggleAppInfo(true));
      })
      .catch((err) => {
        dispatch(actions.submitAppFail(err));
        dispatch(alertActions.error(err.message));
      });
  };
};
